
import { useState } from 'react';
import { Assessment, Category } from '@/types/assessment';
import { AssessmentSidebar } from './sidebar/AssessmentSidebar';
import { AssessmentSidebarWhite } from './sidebar/AssessmentSidebarWhite';
import { MobileMenuButton } from './sidebar/MobileMenuButton';
import { cn } from '@/lib/utils';

interface AssessmentLayoutProps {
  children: React.ReactNode;
  assessment: Assessment;
  categories: Category[];
  currentCategoryIndex: number;
  currentStep: string;
  currentQuestionIndex?: number;
  responses?: Record<string, any>;
  onNavigateToQuestion?: (categoryIndex: number, questionIndex: number) => void;
}

const AssessmentLayout = ({ 
  children, 
  assessment, 
  categories, 
  currentCategoryIndex,
  currentStep,
  currentQuestionIndex = 0,
  responses = {},
  onNavigateToQuestion
}: AssessmentLayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex-1 flex flex-col min-h-0">
      {/* Main Content */}
      <div className="flex flex-1">
        {/* Sidebar for categories navigation - shown during questions */}
        {currentStep === 'questions' && (
          <AssessmentSidebar
            categories={categories}
            currentCategoryIndex={currentCategoryIndex}
            currentQuestionIndex={currentQuestionIndex}
            responses={responses}
            onNavigateToQuestion={onNavigateToQuestion}
            sidebarOpen={sidebarOpen}
            toggleSidebar={toggleSidebar}
            assessmentTitle={assessment.title}
          />
        )}

        {/* Main content area */}
        <main className={cn("flex-1", "bg-gray-50")}>
          {/* Mobile menu button */}
          {currentStep === 'questions' && (
            <MobileMenuButton toggleSidebar={toggleSidebar} />
          )}

          <div className={
            currentStep === 'welcome'
              ? "w-full h-full" 
              : "container mx-auto px-4 pb-4 pt-2"
          }>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AssessmentLayout;
